import { Icon, IconProps } from '@chakra-ui/react'

export default function ChatMessageAddSquareIcon(props: IconProps) {
  return (
    <Icon
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      color={'#868E96'}
      {...props}
    >
      <path
        d="M8 14L9.33333 11.3333H12.6667C13.4033 11.3333 14 10.7367 14 10V3.33333C14 2.59667 13.4033 2 12.6667 2H3.33333C2.59667 2 2 2.59667 2 3.33333V10C2 10.7367 2.59667 11.3333 3.33333 11.3333H6"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.99984 4.66666V8.66666"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10 6.66668H6"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Icon>
  )
}
